import React from 'react';

const LiveExecutionsGraph = ({ executions }) => {
	return null
}

export default LiveExecutionsGraph
